<template>
  <div class="home">
    <!-- Detail route -->
    <transition name="detail_slide">
      <router-view/>
    </transition>
    <!-- Widget Container -->
    <div
      v-for="container in containers"
      :key="container.id"
      :style="`
        position: absolute;
        left: calc(${(container.position?container.position[0]:0) * (1/columns)} * (100vw - 32px)  + 10px);
        top: calc(${(container.position?container.position[1]:0) * (1/columns)} * (100vw - 32px) + 10px);
        width: calc(${container.width * (1/columns)} * (100vw - 32px));
        height: calc(${container.height * (1/columns)} * (100vw - 32px));
        padding: 9px;
        transition: all 0.3s ease-in-out;
      `"

      >
      <!-- Standard Vorlagen -->
      <!-- <div class="widget" :style="`background-color: ${container.color}`" v-if="container.widget === 'one'">one {{container.position}}</div>
      <div class="widget" :style="`background-color: ${container.color}`" v-else-if="container.widget === 'two'">two {{container.position}}</div>
      <div class="widget" :style="`background-color: ${container.color}`" v-else-if="container.widget === 'three'">three {{container.position}}</div> -->
      <!-- :class="`widgetLogo ${$vuetify.theme.dark ? 'image-logo-white' : 'image-logo-black'}`" -->

      <HomeWidget @click.native="setPosition()" :class="`widgetLogo ${$vuetify.theme.dark ? 'image-logo-white' : 'image-logo-black'}`" v-if="container.widget === 'logo'">
          <v-btn style="border: solid 1px white;
          border-radius: 20px; background-color: #121212; font-size: 22px;
          font-weight: 700;position: absolute; left: 50%; top: 0px; width: 90%; z-index: 2; transform: translateX(-50%);" v-if="$vuetify.breakpoint.smAndDown" :href="getLoginUrl"> {{$t('Buttons.Login')}} </v-btn>
      </HomeWidget>
      <HomeWidget @click.native="$router.push({name: 'TaktingDescriptionMain'})" class="widget" description="Who are we and what is TAKT.ing about ?" isMessage="true" v-else-if="container.widget === 'takting'"/>
      <HomeWidget @click.native="$router.push({name: 'TaktTraining'})" class="widget image-training" :header="$t('Home.Home.TaktTraining.Header')" :description="$t('Home.Home.TaktTraining.Description')" v-else-if="container.widget === 'training'"/>
      <HomeWidget @click.native="$router.push({name: 'TaktTraining'})" class="widget color-white" :header="$t('Home.Home.TaktTraining.Header')" video="https://takting-images.s3.us-east-2.amazonaws.com/simulation_homepage.mp4" description="" v-else-if="container.widget === 'trainingVideo'"/>
      <HomeWidget @click.native="$router.push({name: 'TaktAppMain'})" class="widget image-app" :header="$t('Home.Home.TaktApp.Header')" :description="$t('Home.Home.TaktApp.Description')" v-else-if="container.widget === 'app'"/>
      <HomeWidget @click.native="openNewTab('https://knowledge.takting.com/?lang=en')" class="cursor-pointer widget image-knowledge" :header="$t('Home.Home.TaktKnowledge.Header')" :description="$t('Home.Home.TaktKnowledge.Description')" v-else-if="container.widget === 'knowledge'"/>
      <HomeWidget @click.native="$router.push({name: 'AlgorithmicFlowMain'})" class="widget image-algorithmic-flow" :header="$t('Home.Home.AlgorithmicFlow.Header')" :description="$t('Home.Home.AlgorithmicFlow.Description')" v-else-if="container.widget === 'algorithmicFlow'"/>
      <HomeWidget @click.native="$router.push({name: 'PowerOfTaktOne'})" class="widget image-takt-power" :header="$t('Home.Home.PowerOfTakt.Header')" :description="$t('Home.Home.PowerOfTakt.Description')" v-else-if="container.widget === 'taktPower'"/>
      <HomeWidget @click.native="$router.push({name: 'ComingSoonMain'})" class="widget image-takt-news" :header="$t('Home.Home.ComingSoon.Header')" :description="$t('Home.Home.ComingSoon.Description')" v-else-if="container.widget === 'comingSoon'"/>
      <HomeSocial class="widget" v-else-if="container.widget === 'social'"/>
      <HomeWidget @click.native="$router.push({name: 'HomeWorkbenchMain'})" class="widget image-workbench" :header="$t('Home.Home.WorkBench.Header')" :description="$t('Home.Home.WorkBench.Description')" v-else-if="container.widget === 'workbench'"/>
      <HomeWidget @click.native="$router.push({name: 'TaktPartnersMain'})" class="widget image-takt-partners" :header="$t('Home.Home.TaktPartners.Header')" :description="$t('Home.Home.TaktPartners.Description')" v-else-if="container.widget === 'taktPartners'"/>
      <HomeWidget @click.native="$router.push({name: 'TaktConnectionMain'})" class="widget image-takt-connection" :header="$t('Home.Home.TaktConnect.Header')" :description="$t('Home.Home.TaktConnect.Description')" v-else-if="container.widget === 'taktConnect'"/>
      
      <HomeWidget @click.native="$router.push({name: 'ResearchMain'})" class="widget " :isMessage="true" messageSize="20px" :header="['Ongoing ', 'Research']" description="TAKT.ing is at the forefront of groundbreaking research in the field of digitizing the construction industry." v-else-if="container.widget === 'research'"/>

      <HomeWidget @click.native="openNewTab('https://www.process-boards.de/')" class="widget image-process-boards" :header="$t('Home.Home.ProcessBoards.Header')" :description="$t('Home.Home.ProcessBoards.Description')" v-else-if="container.widget === 'processBoards'"/>
      <HomeWidget class="widget" style="cursor: default" messageSize="28px" description="Find trainer, knowledge and tools for your TAKT.journey" noHover="true" isMessage="true" v-else-if="container.widget === 'textTwo'"/>
      <HomeWidget :class="`widget ${$vuetify.theme.dark ? 'image-pikto-one-white' : 'image-pikto-one-black'}`" style="cursor: default" noHover="true" header="" description="" v-else-if="container.widget === 'piktoOne'"/>
      <HomeWidget :class="`widget ${$vuetify.theme.dark ? 'image-pikto-two-white' : 'image-pikto-two-black'}`" style="cursor: default; " noHover="true" header="" description="" v-else-if="container.widget === 'piktoTwo'"/>
      <HomeRegistrationWidget class="widget" v-else-if="container.widget === 'register'">
        <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 5px">
        <v-btn @click="$router.push({name: 'Apply'})" class="home-register-button"> {{$t('Home.Home.Register.Apply')}} </v-btn>
        <v-btn @click="$router.push({name: 'Subscribe'})" class="home-register-button"> {{$t('Home.Home.Register.Newsletter')}} </v-btn>
      </div>
      </HomeRegistrationWidget>
      <HomeWidget @click.native="$router.push({name: 'GeneralCareer'})" class="widget image-careers" :header="$t('Home.Home.TaktCareer.Header')" :description="$t('Home.Home.TaktCareer.Description')" v-else-if="container.widget === 'career'"/>
      <HomeWidget @click.native="copyToClipboard('support@takting.com')" class="widget" v-else-if="container.widget === 'support'" header="support 1" description="Need help? Contact: support@takting.com" :isMessage="true" messageSize="20px" />
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  import { HomeMixin } from '@/mixins/Home.mixin.js'
  import HomeWidget from '@/components/Home/HomeWidget.component.vue'
  import HomeRegistrationWidget from '@/components/Home/HomeRegistrationWidget.component.vue'
  import HomeSocial from '@/components/Home/HomeSocial.component.vue'
  export default {
    props: [],
    components: {
      HomeWidget,
      HomeRegistrationWidget,
      HomeSocial
    },
    mixins: [
      HomeMixin,
    ],
    methods: {
      openNewTab(route) {
        window.open(route)
      },
      copyToClipboard(s){
        navigator.clipboard.writeText(s);
      }
    },
    computed: {
      ...mapGetters('Auth', [
        'getLoginUrl'
      ]),
    }
  }
</script>
<style>
.home-register-button {
  /* border: solid 1px grey; */
  /* margin-top: 5px; */
  border-radius: 10px;
  width: calc(100% - 10%);
  text-align: center;
  font-size: 30px;
  background-color: grey;
  /* opacity: 0.7; */
}
  .home {
    height: calc(100% - 78px) !important;
    width: 100%;
    padding: 10px !important;
  }
  .widgetLogo {
    height: 100%;
    width: 100%;
    border-radius: 20px;
    border: solid 1px white;
  }
  .widget {
    height: 100%;
    width: 100%;
    display: flex;
    border: solid 1px var(--v-primary-base);
    border-radius: 20px;
    /* background: linear-gradient(to bottom,rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.1),rgba(0, 0, 0, 1)); */
    /* opacity: 0.5; */
    /* justify-content: center; */
    /* align-items: center; */
  }
  .image-logo-black {
    border: hidden;
    padding-top: 5%;
    background: url('~@/assets/TaktingLogoBlack.svg') 0px 10px;
  }
  .image-logo-white {
    border: hidden;
    padding-top: 5%;
    background: url('~@/assets/TaktingLogo.svg') 0px 10px;
  }
  .image-training {
    background-size: 105%;
    background-position: center;
    background-image: url('~@/assets/FotoJet.png');
    color: white;
    /* opacity: 0.5; */
    /* background: linear-gradient(to top, black 0%, white 50%); */
  }
  .image-app {
    background-size: 100%;
    background-position: top;
    background-image: url('~@/assets/TaktPlan.png');
    color: white;
  }
  .image-knowledge {
    background-size: 140%;
    background-position: center;
    background-image: url('~@/assets/KnowledgeOne.jpg');
    color: white;
  }
  .image-algorithmic-flow {
    background-size: 100%;
    background-position: center;
    background-image: url('~@/assets/AlgorithmicFlowThree.jpg');
    color: white;
  }
  .image-takt-power {
    background-size: 350%;
    background-position: center;
    background-image: url('~@/assets/stopwatch.jpg');
    color: white;
  }
  .image-linkedIn {
    background-size: 90%;
    background-position: right;
    background-image: url('~@/assets/LinkedIn.png');
  }
  .image-takt-news {
    background-size: 80%;
    background-position: center;
    /* background-color: white; */
    background-image: url('~@/assets/Rocket.png');
  }
  .image-workbench {
    background-size: 110%;
    background-position: center;
    background-image: url('~@/assets/Workbench.jpg');
    color: white;
  }
  .image-takt-partners {
    background-size: 150%;
    background-position: center;
    background-image: url('~@/assets/TaktPartners.jpg');
    color: white;
  }
  .image-takt-connection {
    background-size: 150%;
    background-position: center;
    background-image: url('~@/assets/TaktConnections.jpg');
    color: white;
  }
  .image-research {
    background-size: 90%;
    background-position: center;
    background-image: url('~@/assets/InvestBW.jpg');
    background-color: white;
  }
  .image-process-boards {
    background-size: 150%;
    background-position: center;
    background-image: url('~@/assets/ProcessBoardsOne.jpg');
    color: white;
  }
  .image-careers {
    background-size: 165%;
    background-position: center;
    background-image: url('~@/assets/employee.png');
    color: white;
  }
  .image-pikto-one-black {
    background-size: 80%;
    background-position: center;
    background-image: url('~@/assets/Black_AI.svg');
  }

  .image-pikto-one-white {
    background-size: 80%;
    background-position: center;
    background-image: url('~@/assets/White_AI.svg');
  }
  .image-pikto-two-black {
    background-size: 80%;
    background-position: center;
    background-image: url('~@/assets/Black_Workbench.svg');
  }
  .image-pikto-two-white {
    background-size: 80%;
    background-position: center;
    background-image: url('~@/assets/White_Workbench.svg');
  }
  .color-white {
    color: white;
  }
  .detail_slide-enter, .detail_slide-leave-to {
  transform: translateY(100vh);
  }
  .detail_slide-enter-active, .detail_slide-leave-active {
    transition: transform 0.2s ease-in-out;
  }
</style>
